import { Typography } from 'antd'
import { Link } from 'react-router-dom'

export const MONO_STYLE = {
  fontFamily: 'monospace',
  fontSize: 12,
  lineHeight: '22px',
  whiteSpace: 'nowrap',
} as const

export const truncateMiddle = (id: string) =>
  id.length > 16 ? `${id.slice(0, 8)}…${id.slice(-6)}` : id

export function MonoId({
  id,
  to,
}: {
  id: string | null | undefined
  to?: string
}) {
  if (!id) return <>{'—'}</>
  return (
    <Typography.Text copyable={{ text: id }} style={MONO_STYLE}>
      {to ? <Link to={to}>{truncateMiddle(id)}</Link> : truncateMiddle(id)}
    </Typography.Text>
  )
}
